import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Button } from 'reactstrap';

import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

import { posApi } from "../../reducers/posSlice";
// import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { useNavigate } from "react-router-dom";

import moment from 'moment-timezone';

const PosListItem = ({pos}) => {
    const navigate = useNavigate()
    const [deleting, setDeleting] = useState(false)
    // const score = useSelector((state) => getScoreByPosId(state, pos.id));

    const dispatch = useDispatch();

    const showDeleteConfirm = (pos) => {
        confirmAlert({
        //   title: 'Confirm to submit',
          message: "Sei sicuro di voler eliminare il PdV con codice: "+pos.code+" ?",
          buttons: [
            {
              label: 'SI',
                onClick: () => { 
                    setDeleting(true)
                    dispatch( posApi.delete(pos) )
                }
            },
            {
                label: 'NO',
                onClick: () => {}
            }
          ]
        });
    }
    
    const getUserCanoncial = (user) => {
        let canonical = `${user.first_name} ${user.last_name}`.trim()
        return canonical.length > 0 ? canonical : user.email
    }

    const getComposedAddress = (pos) => {
        const address = pos.address ? pos.address : ""
        const address_number = pos.address_number ? pos.address_number : ""
        const cap = pos.cap ? pos.cap : ""
        const city = pos.city ? pos.city : ""
        const province = pos.province ? pos.province : ""

        let composedAddress = `${address} ${address_number}, ${cap} ${city} (${province})`.trim()
        composedAddress = composedAddress.replace("   ", " ")
        composedAddress = composedAddress.replace("  ", " ")
        
        return (composedAddress !== ", ()") ? composedAddress : "-";
    }

    const getAlertClassName = (pos) => {
        let num_survey = pos.num_survey
        let score = parseFloat(pos.avg_score.toFixed(2))
        let className = "text-center mb-0 alert "
        
        if(num_survey === 0) className += "alert-light"
        else if(score == 0) className += "alert-light"
        else if(score == 1) className += "alert-danger"
        else if(score > 1 && score <= 2) className += "alert-warning"
        else if(score > 2 && score <= 3) className += "alert-success"
        
        return className
    }

    const formatDate = (dateString) => {
        let desiredFormat = "YYYY-MM-DD HH:mm:ss";
        let timeToBeConverted = moment(dateString, desiredFormat);
        let timeZone = "Europe/Rome";

        return dateString ? timeToBeConverted.tz(timeZone).format(desiredFormat) : <span className="text-light">in sospeso</span>;
    }

    const isWarning = (pos) => {
        let warn = true
        if(pos.last_survey_at) {
            let today = moment()
            let lastSurveyAt = moment(pos.last_survey_at)
            let days = today.diff(lastSurveyAt, 'days');

            warn = days >= 30
            // console.log(pos.last_survey_at, days, warn)
        }

        return warn
    }

    return (
        <tr onClick={() => { navigate(`/pos/${pos.id}/data`) }} style={{cursor: "pointer"}} className={isWarning(pos) ? 'table-warning' : ''}>
            {/* <td style={{ width: "1%" }} >{pos.id}</td> */}
            <td style={{ width: "1%" }} ><code>{pos.code}</code></td>
            <td style={{ width: "15%" }} ><b>{pos.company_name}</b></td>
            <td style={{ width: "5%" }} >{pos.sign}</td>
            <td style={{ width: "5%", whiteSpace: 'nowrap' }} >{pos.group}</td>
            <td style={{ width: "5%", whiteSpace: 'nowrap' }} ><code>{pos.type}</code></td>
            <td style={{ width: "24%", fontSize: '12px' }} >{getComposedAddress(pos)}</td>
            <td style={{ width: "8%" }} >{pos.state}</td>
            <td style={{ width: "8%"}} >{pos.user ? getUserCanoncial(pos.user) : "-"}</td>
            <td style={{ width: "10%", fontSize: '12px'}} >{pos.last_survey_at ? formatDate(pos.last_survey_at) : "-"}</td>
            <td style={{ width: "1%" }} ><div className="text-center alert alert-light mb-0">{pos.num_checks}</div></td>
            <td style={{ width: "1%" }} ><div className={getAlertClassName(pos)} >{parseFloat(pos.avg_score.toFixed(2))}</div></td>
            
            <td style={{ width: "17%", whiteSpace: "nowrap" }} >
                {}
                <Button onClick={(e) => { navigate(`/pos/${pos.id}`); e.stopPropagation(); }} className="btn btn-primary " disabled={deleting} > <i className="fas fa-pencil-alt" /> </Button>
                &nbsp;
                <Button onClick={(e) => { showDeleteConfirm(pos); e.stopPropagation(); }} className="btn btn-danger " disabled={deleting} > <i className="fas fa-trash-alt" /> </Button>
            </td>
        </tr>
    )
}

export default PosListItem;

